const INITIAL_STATE = {
  data: {},
  errors: {}
}
		
const getRoyaltyReportForViewBreakDown = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_ROYALTY_BREAKDOWN_SUCCESSFULLY':
	  return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_ROYALTY_BREAKDOWN_FAILED':
	  return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
		
export default getRoyaltyReportForViewBreakDown;